module.exports = __webpack_public_path__ + "img/edit-oven_props.09540065.png";